import Rest from '@services/Rest';

/**
 * @typedef {ReconcileSubscriptionService}
 */
export default class ReconcileSubscriptionService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/reconcile/pagarme/subscription'
}